import React, {useEffect, useState} from "react";
import {Select, Typography} from "antd";
import {ApiService} from "../../../services/ApiService";
import DefaultPageHeader from "../../../containers/DefaultPageHeader";

const { Option } = Select;

const SystemOperationPage = () => {
    const [files, setFiles] = useState([])
    const [selected, setSelected] = useState('')
    const [content, setContent] = useState('')

    const requestContent = (name) => {
        if (!name) {
            setContent('')
            return
        }
        ApiService.admin.system.log.get(name)
            .onSuccess(setContent)
    }

    useEffect(() => {
        ApiService.admin.system.log.list()
            .onSuccess(data => {
                setFiles(data)
                const first = data && data.length > 0 && data[0];
                setSelected(first)
                requestContent(first)
            })
    }, [])

    const handleSelectChange = (value) => {
        setSelected(value)
        requestContent(value)
    }

    return (
        <>
            <DefaultPageHeader
                title={"系统日志"}
            />

            <Select style={{width: 200}} value={selected} onChange={handleSelectChange}>
                {
                    files.map(file => <Option key={file} value={file}>{file}</Option>)
                }
            </Select>

            <Typography.Paragraph>
                <pre>{content}</pre>
            </Typography.Paragraph>
        </>
    )
}

export default SystemOperationPage